export const getLiterFormula = () => {
    return {
        literFormula: document.getElementById('literFormula').value,
    }
}

export const validateLiterFormula = (body) => {
    if(body.literFormula === '' || body.literFormula < 0.5){
        throw new Error('Cantidad de litros erronea');
    }
}

export const buildStickerBox = () => {
    return document.getElementById('kilo').value
}

export const validateStickerBox = (newKilos) => {
    if(newKilos === '' || newKilos <= 0.1){
        throw new Error('La cantidad de kilos es erronea');
    }
  
}

export const getUpdateBody = () => {
    return {
        literformula: document.getElementById('literformula').value,
        cod_process: document.getElementById('cod_process').value,
        color: document.getElementById('color').value,
        type_quantity: document.getElementById('type_quantity').value,
        quantity: document.getElementById('quantity').value,
        inspected : document.getElementById('inspected').value,
        price : document.getElementById('price').value,
        productPrice : document.getElementById('productPrice').value,
    }
}
export const validateUpdateBody = (body) => {

    if(body.quantity === '' || body.quantity < 1){
        return 'eq';
    }
    if(body.literformula === '' || body.literformula < 0){
        return 'ef';
    }
    if(body.price === '' || body.price <= 0){
        return 'pr';
    }
  
    return false;
}
